export const COLORS = {
    white: '#fff',
    dark: '#000',
    blue: '#245ddd',
}